export default __webpack_public_path__ + "static/media/team-thumbnail.7b324f7d.jpg";